// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subscription, ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// NGRX
// Service
import { SubheaderService } from '../../../../../core/_base/layout';
import { LayoutUtilsService,  MessageType } from '../../../../../core/_base/crud';
import { ThanhPhamService } from '../thanh-pham-service/thanh-pham.service';
//Models
import { ThanhPhamModel,FileImportHH } from '../thanh-pham-model/thanh-pham.model';
import { ListImageModel } from '../thanh-pham-model/thanh-pham.model';
import { DungChungService } from '../../dung-chung/__services/dung-chung.service'
import { FunctionPublic } from './../../dung-chung/__function/common_function';
import { ContentComponent } from 'app/views/pages/components/content-component/content-component.component';
import { ProductStatusText } from '../../../../../shared/constants/product-status.constant';
import { ProductStatus } from '../../../../../shared/enums/product-status.enum';
@Component({
	selector: 'kt-thanh-pham-edit',
	templateUrl: './thanh-pham-edit.component.html',
	styleUrls: ['../thanh-pham.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThanhPhamEditComponent implements OnInit, OnDestroy {
	// Public properties
	@ViewChild('fileUpload', { static: true }) fileUpload;
	ThanhPham: ThanhPhamModel;
	ThanhPhamForm: FormGroup;
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	fixedPoint = 2;
	isZoomSize: boolean = false;
	flagFileImport: FileImportHH = new FileImportHH();
	flagFileDownload: any;

	listId_NhomHH : any[] = [];
	selectId_NhomHH : string = '0';
	listDVT1 : any[] = [];
	selectDVT1 : string = '0';
	selectDVT2 : string = '0';
	selectDVT3 : string = '0';
	listBoPhanKiemTra : any[] = [];
	selectBoPhanKiemTra : string = '0';
	selectBoPhanGiamSat : string = '0';
	listListNCC : any[] = [];
	selectListNCC : string[] = [];
	listListKH : any[] = [];
	selectListKH : string[] = [];
	listDongSanPham : any[] = [];
	idLoaiHH = -1;
	tmpDVT1:any;

	IsValueRd: string = '';
	LinkAvatar: string = '';
	urlsDisplay = [];
	urlsSave = [];
	item: any;

	imageDaiDien: any;
	imgvlDaiDien: any;
	picDaiDien: ListImageModel[] = []

	imagedata: any;
	imgvl: any;

	tongFileChon: number = 0;

	private componentSubscriptions: Subscription;

	listKho:any[]=[];
	select_Kho: string[] = [];
	filtered_Kho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Kho_FilterCtrl: string = '';
	filtered_KH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KH_FilterCtrl: string = '';
	haveElement_Kho: boolean = false;
  isLoading: boolean = false;
  statusText = ProductStatusText;
	constructor(
		public dialogRef: MatDialogRef<ThanhPhamEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private ThanhPhamFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private changeDetect:ChangeDetectorRef,
		private thanhphamsService: ThanhPhamService,
		private DungChungService: DungChungService
		) {dialogRef.disableClose = true;}
	/**
	 * On init
	 */
	ngOnInit() {
		this.viewLoading = false;
		this.ThanhPham = this.data.data;

		this.idLoaiHH = this.data.idLoaiHH;
		this.tmpDVT1 = this.ThanhPham.DVT1;

		this.ListId_NhomHH(this.idLoaiHH);
		this.ListDVT1();
		this.ListBoPhanKiemTra();
		this.ListListKH();
		this.loadListKho();
		this.ListDongSanPham();

		this.imagedata = {
			RowID: "",
			Title: "",
			Description: "",
			Required: false,
			Files: []
		}
		this.imageDaiDien = {
			RowID: "",
			Title: "",
			Description: "",
			Required: false,
			Files: []
		}
		if (this.ThanhPham.Id_HH > 0) {
			if (this.ThanhPham.listLinkImage.length > 0) {
				for (let i = 0; i < this.ThanhPham.listLinkImage.length; i++) {
					let a = {
						strBase64: "",
						filename: "",
						extension: "",
						Type: 1,
						type: "image/png",
						src: this.ThanhPham.domain + this.ThanhPham.listLinkImage[i].src,
						IsAdd: false,
						IsDel: false
					};
					this.imagedata.Files.push(a)
				}
			}
			if (this.ThanhPham.HinhDaiDien != null && this.ThanhPham.HinhDaiDien != '') {

				let a = {
					strBase64: "",
					filename: "",
					extension: "",
					Type: 1,
					type: "image/png",
					src: this.ThanhPham.domain + this.ThanhPham.HinhDaiDien,
					IsAdd: false,
					IsDel: false
				};
				this.imageDaiDien.Files.push(a)
				let tmpElement = new ListImageModel();
				tmpElement.clear();
				tmpElement.src = this.ThanhPham.domain + this.ThanhPham.HinhDaiDien;
				this.picDaiDien.push(tmpElement);
			}
		}


		this.createForm();
		this.ThanhPhamForm.get("DVTThongKeTon").valueChanges.subscribe(
			(value) => {
				this.ThanhPhamForm.controls["DVT2"].clearValidators();
				this.ThanhPhamForm.controls['DVT2'].updateValueAndValidity();
				this.ThanhPhamForm.controls["DVT3"].clearValidators();
				this.ThanhPhamForm.controls['DVT3'].updateValueAndValidity();	
				if(value == "2"){
					this.ThanhPhamForm.controls["DVT2"].setValidators(Validators.required);
					this.ThanhPhamForm.controls['DVT2'].updateValueAndValidity();
				}
				else if(value == "3"){
					this.ThanhPhamForm.controls["DVT3"].setValidators(Validators.required);
					this.ThanhPhamForm.controls['DVT3'].updateValueAndValidity();
				}
				
			}
		);
		this.thanhphamsService.data_import.subscribe(res => {
			if(res != null && res != undefined){
				for(let i = 0; i < res.length; i++){
					this.flagFileImport = new FileImportHH();
					this.flagFileImport.clear();
					this.flagFileImport.filename = res[i].fileName;
					this.flagFileImport.extension = res[i].extension;
					this.flagFileImport.base64 = res[i].base64;
				}
			}
		});
	}
	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	/**
	 * Create form
	 */
	createForm() {
		this.ThanhPhamForm = this.ThanhPhamFB.group({
				maHH: [(this.ThanhPham.MaHH == null) ? '' : this.ThanhPham.MaHH, Validators.required],
				tenHH: [(this.ThanhPham.TenHH == null  || this.ThanhPham.TenHH == '') ?  ''	: this.ThanhPham.TenHH, Validators.required],
				ghiChu: [(this.ThanhPham.GhiChu == null) ? '' : this.ThanhPham.GhiChu],
				ThoiHanSuDung: [(this.ThanhPham.ThoiHanSuDung == null) ? 0 : this.ThanhPham.ThoiHanSuDung, Validators.required],
				phanTramThueVAT: [(this.ThanhPham.PhanTramThueVAT == null) ? 0 : this.ThanhPham.PhanTramThueVAT],
				tonKhoToiThieu: [(this.ThanhPham.TonKhoToiThieu == null  || this.ThanhPham.TonKhoToiThieu == '') ? '0.00' :
						this.f_currency(this.formatNumber(this.ThanhPham.TonKhoToiThieu))
				],
				dieuKienBaoQuan: [(this.ThanhPham.DieuKienBaoQuan == null) ? '' : this.ThanhPham.DieuKienBaoQuan],
				quyDoiDVT2: [(this.ThanhPham.QuyDoiDVT2 == null || this.ThanhPham.QuyDoiDVT2 == '') ? '0,00000' : this.f_dynamic(this.ThanhPham.QuyDoiDVT2)],
				quyDoiDVT3: [(this.ThanhPham.QuyDoiDVT3 == null || this.ThanhPham.QuyDoiDVT3 == '') ? '0,00000' : this.f_dynamic(this.ThanhPham.QuyDoiDVT3)],
				DVTThongKeTon: [(this.ThanhPham.DVTThongKeTon == null || this.ThanhPham.DVTThongKeTon == 0) ? 1 : this.ThanhPham.DVTThongKeTon.toString()],
				CanPhieuKt: [this.ThanhPham.CanPhieuKt
				],
				imageDaiDienControl: [this.imageDaiDien.Files],
				imageControl: [this.imagedata.Files],
				QuyCachDongGoi:[(this.ThanhPham.QuyCachDongGoi == null||this.ThanhPham.QuyCachDongGoi == '') ? '' : this.ThanhPham.QuyCachDongGoi],
				DungSaiChoPhepNhap:[(this.ThanhPham.DungSaiChoPhepNhap == null||this.ThanhPham.DungSaiChoPhepNhap == '') ? '' : this.f_currency(this.formatNumber(this.ThanhPham.DungSaiChoPhepNhap))],
				QuyChuan:[(this.ThanhPham.QuyChuan.toString() == '') ? '20.00' : this.f_currency(this.formatNumber(this.ThanhPham.QuyChuan))],
				CanTren:[(this.ThanhPham.CanTren.toString() == '') ? '20.3' : this.f_currency(this.formatNumber(this.ThanhPham.CanTren))],
				CanDuoi:[(this.ThanhPham.CanDuoi.toString() == '') ? '19.9' : this.f_currency(this.formatNumber(this.ThanhPham.CanDuoi))],

				KhoMacDinh:[(this.ThanhPham.KhoMacDinh == null||this.ThanhPham.KhoMacDinh == '') ? '' : this.ThanhPham.KhoMacDinh.toString()],
				DVT1: [(this.ThanhPham.DVT1 == null || this.ThanhPham.DVT1 == 0) ? '' :
				this.ThanhPham.DVT1.toString(),Validators.required
				],
				DVT2: [(this.ThanhPham.DVT2 == null || this.ThanhPham.DVT2 == 0) ? '' :
					this.ThanhPham.DVT2.toString()
				],
				DVT3: [(this.ThanhPham.DVT3 == null || this.ThanhPham.DVT3 == 0) ? '' :
					this.ThanhPham.DVT3.toString()
				],

				idLoaiHH: [(this.ThanhPham.Id_NhomHH == null || this.ThanhPham.Id_NhomHH == 0) ? '' :
				this.ThanhPham.Id_NhomHH.toString(),Validators.required
				],
				DongSanPham: [(this.ThanhPham.DongSanPham == null || this.ThanhPham.DongSanPham == 0) ? '' :
				this.ThanhPham.DongSanPham.toString(),Validators.required
				],
				FileName:[(this.ThanhPham.TenFileGoc  == null) ? '' : this.ThanhPham.TenFileGoc],
				BCSX_WarningRange: [(this.ThanhPham.BCSX_WarningRange == null || this.ThanhPham.BCSX_WarningRange == '') ? '' : this.f_currency(this.formatNumber(this.ThanhPham.BCSX_WarningRange))],
        STATUS: [(this.ThanhPham.Status == null ? ProductStatus.Active : this.ThanhPham.Status.toString()), Validators.required],
		});
		//this.ThanhPhamForm.controls['DVT1'].disable() //Nếu chỉnh sửa thì disable field đơn vị tính
		if (this.ThanhPham.Id_HH > 0) {
			this.selectId_NhomHH = '' + this.ThanhPham.Id_NhomHH;
			this.selectDVT1 = '' + this.ThanhPham.DVT1;
			this.selectDVT2 = '' + this.ThanhPham.DVT2;
			this.selectDVT3 = '' + this.ThanhPham.DVT3;
			this.selectBoPhanKiemTra = '' + this.ThanhPham.BoPhanKiemTra;
			this.selectBoPhanGiamSat = '' + this.ThanhPham.BoPhanGiamSat;
			this.ThanhPham.listKH.forEach(kh => {
				this.selectListKH.push('' + kh);
			})
		}

		// Dynamically switch the required validator for the field: 'quyDoiDVT2' based on the value of the fields 'DVT2'
		this.switchFieldRequire('DVT2', 'quyDoiDVT2');
		// Dynamically switch the required validator for the field: 'quyDoiDVT3' based on the value of the fields 'DVT3'
		this.switchFieldRequire('DVT3', 'quyDoiDVT3');

		this.changeDetectView();
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
			if (this.ThanhPham.Id_HH == 0) {
				return 'Thêm mới thành phẩm';
			}
        return `Chỉnh sửa thành phẩm - ${this.ThanhPham.TenHH} `;
	}
	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.ThanhPhamForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}
	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSubmit(type: boolean) {
    this.isLoading = true;
		this.hasFormErrors = false;
		const controls = this.ThanhPhamForm.controls;

		/** check form */
		if (this.ThanhPhamForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
      this.isLoading = false;
			return;
		}
		

		// tslint:disable-next-line:prefer-const
		let editedThanhPham = this.prepareThanhPhams();
		if (this.ThanhPham.Id_HH > 0) {
			this.updateThanhPham(editedThanhPham)
			return;
		}
		this.addThanhPham(editedThanhPham,type);
	}
	/**
	 * Returns object for saving
	 */
	prepareThanhPhams(): ThanhPhamModel {
		const controls = this.ThanhPhamForm.controls;
		const _ThanhPham = new ThanhPhamModel();
		_ThanhPham.clear();
		_ThanhPham.Id_NhomHH = controls['idLoaiHH'].value;
		_ThanhPham.DVT1 = controls['DVT1'].value;
		_ThanhPham.DVT2 =controls['DVT2'].value;
		_ThanhPham.DVT3 = controls['DVT3'].value;
		_ThanhPham.BoPhanKiemTra = +this.selectBoPhanKiemTra;
		_ThanhPham.BoPhanGiamSat = +this.selectBoPhanGiamSat;
		_ThanhPham.listKH = this.selectListKH;
		_ThanhPham.MaHH = controls['maHH'].value;
		_ThanhPham.TenHH = controls['tenHH'].value;
		_ThanhPham.GhiChu = controls['ghiChu'].value;
		_ThanhPham.QuyDoiDVT2 = controls['quyDoiDVT2'].value ? this.f_number(controls['quyDoiDVT2'].value) : '';
		_ThanhPham.QuyDoiDVT3 = controls['quyDoiDVT3'].value ? this.f_number(controls['quyDoiDVT3'].value) : '';
		_ThanhPham.DVTThongKeTon = 1;

		_ThanhPham.TonKhoToiThieu = controls['tonKhoToiThieu'].value.replace(/,/g, "");
		_ThanhPham.ThoiHanSuDung = controls['ThoiHanSuDung'].value;
		_ThanhPham.PhanTramThueVAT = controls['phanTramThueVAT'].value;
		_ThanhPham.DieuKienBaoQuan = controls['dieuKienBaoQuan'].value;
		_ThanhPham.CanPhieuKt = controls['CanPhieuKt'].value;
		_ThanhPham.QuyCachDongGoi = controls['QuyCachDongGoi'].value;
		_ThanhPham.DungSaiChoPhepNhap = controls['DungSaiChoPhepNhap'].value;
		_ThanhPham.QuyChuan = controls['QuyChuan'].value;
		_ThanhPham.CanTren = controls['CanTren'].value;
		_ThanhPham.CanDuoi = controls['CanDuoi'].value;
		_ThanhPham.KhoMacDinh = controls['KhoMacDinh'].value==''?'0':controls['KhoMacDinh'].value;
		_ThanhPham.DongSanPham = +controls['DongSanPham'].value;
		_ThanhPham.File_TieuChuan = this.ThanhPham.File_TieuChuan;
		_ThanhPham.FileImport = this.flagFileImport;

		_ThanhPham.Id_LHH=this.idLoaiHH.toString();
		this.imgvl = controls['imageControl'].value;
		_ThanhPham.listLinkImage = [];

		this.imgvlDaiDien = controls['imageDaiDienControl'].value;

		_ThanhPham.BCSX_WarningRange = controls['BCSX_WarningRange'].value;
		_ThanhPham.Status = Number(controls['STATUS'].value);

		if (this.imgvl.length > 0) {
			for (let i = 0; i < this.imgvl.length; i++) {
				const md = new ListImageModel();
				md.strBase64 = this.imgvl[i].strBase64;
				md.filename = this.imgvl[i].filename;
				md.src = this.imgvl[i].src;
				md.IsAdd = this.imgvl[i].IsAdd;
				md.IsDel = this.imgvl[i].IsDel;
				md.IsImagePresent = false;
				_ThanhPham.listLinkImage.push(md);
			}
		}

		if(this.imgvlDaiDien.length > 0){
			for (let i = 0; i < this.imgvlDaiDien.length; i++) {
				const md = new ListImageModel();
				md.strBase64 = this.imgvlDaiDien[i].strBase64;
				md.filename = this.imgvlDaiDien[i].filename;
				md.src = this.imgvlDaiDien[i].src;
				md.IsAdd = this.imgvlDaiDien[i].IsAdd;
				md.IsDel = this.imgvlDaiDien[i].IsDel;
				md.IsImagePresent = true;
				_ThanhPham.listLinkImage.push(md);
			}
		}

		//gán lại giá trị id
		if (this.ThanhPham.Id_HH > 0) {
			_ThanhPham.Id_HH = this.ThanhPham.Id_HH;
		}
		return _ThanhPham;
	}
	/**
	 * Add item
	 *
	 * @param _ThanhPham: ThanhPhamModel
	 * @param withBack: boolean
	 */
	addThanhPham(_ThanhPham: ThanhPhamModel, withBack: boolean = false) {
		this.thanhphamsService.createThanhPham(_ThanhPham).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.status == 1) {
          this.isChange = true;
          const message = `Thành phẩm mới đã được thêm.`;
          this.layoutUtilsService.showInfo(message);
          this.ThanhPhamForm.reset();
          this.ThanhPham.clear();
          this.ThanhPham.DVT1 = this.tmpDVT1;
          this.createForm();

          this.selectBoPhanKiemTra = '';
          this.selectBoPhanGiamSat = '';

          this.selectListKH = [];
          this.changeDetectView();
          if(withBack)
            this.dialogRef.close({isChange: this.isChange});
        }
        else {
          this.layoutUtilsService.showErorr(res.error.message);
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.layoutUtilsService.showErorr('Có lỗi xảy ra khi thêm thành phẩm');
      }
		});
	}
	/**
	 * Update item
	 *
	 * @param _ThanhPham: ThanhPhamsModel
	 * @param withBack: boolean
	 */
	updateThanhPham(_ThanhPham: ThanhPhamModel, withBack: boolean = false) {
		this.thanhphamsService.updateThanhPham(_ThanhPham).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.status == 1) {
          this.isChange = true;
          const message = `Thành phẩm đã được cập nhật`;
          this.layoutUtilsService.showInfo(message);
          this.dialogRef.close({isChange: this.isChange});
        }
        else {
          this.layoutUtilsService.showErorr(res.error.message);
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.layoutUtilsService.showErorr('Có lỗi xảy ra khi cập nhật thành phẩm');
      }
		});
	}
	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	closeDialog(){
		this.dialogRef.close(this.isChange);
	}
	ListId_NhomHH(idLoaiHH: any){
		this.thanhphamsService.listId_NhomHH(idLoaiHH).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_NhomHH = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ListDVT1(){
		this.thanhphamsService.listDVT1().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDVT1 = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}

	ListBoPhanKiemTra(){
		this.DungChungService.listPhongBanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listBoPhanKiemTra = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ValidateChangeNumberEvent(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == '.'){
					count += 1;
				}
			}
		}
		else{
			for(let i = 0; i < event.length; i++){
				if(event[i] == '.'){
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	changeValueOfForm(controlName: string, event: any){
		if(this.ValidateChangeNumberEvent(event)){
			let tmpValue = this.ThanhPhamForm.controls[controlName].value.replace(/,/g, "");
			this.ThanhPhamForm.controls[controlName].setValue(
					this.f_currency(this.formatNumber(tmpValue))
			);
		}
		else{
			this.ThanhPhamForm.controls[controlName].setValue(event.target.value);
		}
	}
	f_convertDateTime(date: string){
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert = year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return a.getFullYear() + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + ("0" + (a.getDate())).slice(-2);
	}
	resizeDialog(){
		if(!this.isZoomSize){
			this.dialogRef.updateSize('100vw', '100vh');
			this.isZoomSize = true;
		}
		else if(this.isZoomSize){
			this.dialogRef.updateSize('900px', 'auto');
			this.isZoomSize = false;
		}
	}
	showCachTaoMa(){
		// const _description: string = 'Đây là cách tạo mã cho thành phẩm';
		// this.layoutUtilsService.showInfo(_description);

		const dialogRef = this.dialog.open(ContentComponent);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) { return; }
		});
	}

	//#region Kiểm tra định dạng số lượng
	keyUpInputKhoiLuong(event) {
		FunctionPublic.cvKeyUp(event);
	}

	ListListKH(){
		this.thanhphamsService.listListKH().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listListKH = res.data;
				this.filtered_KH.next(this.listListKH.slice());
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	filterListKH() {

		if (!this.listListKH) {
			return;
		}
		// get the search keyword
		let search = this.KH_FilterCtrl;
		if (!search) {
			this.filtered_KH.next(this.listListKH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_KH.next(
			this.listListKH.filter(ts =>
				(ts.TenKH).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	loadListKho(){
		this.DungChungService.listKho().subscribe(res=>{
			if(res&&res.status==1){
				this.listKho=res.data;
				this.filtered_Kho.next(this.listKho.slice());
				this.changeDetectView();
			}else{
				this.layoutUtilsService.showErorr(res.error.message);
			}
		})
	}

	filterListKho() {

		if (!this.listKho) {
			return;
		}
		// get the search keyword
		let search = this.Kho_FilterCtrl;
		if (!search) {
			this.filtered_Kho.next(this.listKho.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_Kho.next(
			this.listKho.filter(ts =>
				(ts.MaKho+' - '+ ts.TenKho).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

	clearSelectKho(event: any) {
		this.ThanhPhamForm.controls["KhoMacDinh"].setValue('');
		event.stopPropagation();
	}

	ListDongSanPham(){
		this.thanhphamsService.listDongSanPham().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDongSanPham = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	selectFile() {
		let el: HTMLElement = this.fileUpload.nativeElement as HTMLElement;
		el.click();
	}
	FileSelected(evt: any) {
		this.ThanhPham.File_TieuChuan = 0;
		if (evt.target.files && evt.target.files.length) {

			let fileNameList = [];
			for(let i = 0; i < evt.target.files.length; i++){
				let file = evt.target.files[i];
				this.flagFileDownload = file;
				let fileName = file.name;
				fileNameList.push(fileName);
			}
			let listFileNameStr = fileNameList[0];
			for(var i = 1; i < fileNameList.length; i++){
				listFileNameStr += ', ' + fileNameList[i];
			}
			this.ThanhPhamForm.controls["FileName"].setValue(listFileNameStr);

			let el: any = this.fileUpload.nativeElement;
			var service = this.thanhphamsService;
			var useBase64: boolean = true;
			let tmpDataArray: any = [];

			for (var idx = 0; idx < el.files.length; idx++) {
				var extension = el.files[idx].name.split('.').pop();
				var fileName = el.files[idx].name.substring(0,el.files[idx].name.indexOf(extension) - 1);

				let reader = new FileReader();
				reader.readAsDataURL(el.files[idx]);
				reader.onload = function () {
					let base64Str = reader.result as String;
					var metaIdx = base64Str.indexOf(';base64,');

					base64Str = base64Str.substr(metaIdx + 8);
					var data = {
						fileName: fileName,
						base64: base64Str,
						extension: extension
					};

					tmpDataArray.push(data);
					service.data_import.next(tmpDataArray);
				};
			}
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
	}
	checkNumber(){
		if(this.ThanhPhamForm.controls["phanTramThueVAT"].value < 0)
			this.ThanhPhamForm.controls["phanTramThueVAT"].setValue(0);
		if(this.ThanhPhamForm.controls["phanTramThueVAT"].value > 100)
			this.ThanhPhamForm.controls["phanTramThueVAT"].setValue(100);
		this.changeDetectView();
	}
	changeValueFormFourPoint(controlName: string, event: any) {
		let tmpValue = this.ThanhPhamForm.controls[controlName].value.replace(/,/g, "");
		this.ThanhPhamForm.controls[controlName].setValue(FunctionPublic.fmFourPoint(tmpValue, event));
	}

	f_dynamic(item: any = "0.00000", dynamic = 5){
		return FunctionPublic.F_NUMBER_DYNAMIC(item, dynamic);
	}

	changeInputOfForm(controlName: string, event: any, min: number = 0, formGroup) {
		const VALUE_EMPTY = "";
		const MIN_VALUE = min;
		const REGEX_COMMA = /,/g;
		const VALUE_DEFAULT = 0.00000;
		var controls = formGroup.controls;
		var valueControl = controls[controlName].value;
		// .. Giá trị trống thì lấy giá trị min
		if (valueControl == VALUE_EMPTY) controls[controlName].setValue(this.f_number(MIN_VALUE));
		// .. Giá trị không xác thực gán lại 0.0
		if (isNaN(valueControl)) valueControl = VALUE_DEFAULT;
		// .. Giá trị nhỏ hơn min thì = min
		if (Number(valueControl) < min) valueControl = MIN_VALUE;
		// .. Valid mới set giá trị
		if (!controls[controlName].invalid) controls[controlName].setValue(this.f_number(valueControl));
		// .. Giá trị "," thì gán về min
		if (valueControl.toString().indexOf(REGEX_COMMA) == 0 && valueControl.length == 1) valueControl = MIN_VALUE;
		controls[controlName].setValue(this.f_number(valueControl));
	}
	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, 5);
	}

	// Dynamically switch the required validator based on the value of another field
	switchFieldRequire(controlName: string, fieldRequire: string) {
		const form = this.ThanhPhamForm.controls;

		// Check require if the controlName field has a value
		const required = form[controlName].value != '';

		// Set the validators for the fieldRequire control based on the value of controlName
		form[fieldRequire].setValidators(
			required ? Validators.compose([Validators.required, this.minValidator(0.00001)]) : null
		);

		// Update the validity status of the fieldRequire control
		form[fieldRequire].updateValueAndValidity();
	}

	// Custom validator function for minimum value
	minValidator(minValue: number) {
		return (control: AbstractControl): ValidationErrors | null => {
			// Extract the value from the form control and convert it to a number
			const value = this.f_number(control.value ? control.value : 0);

			// Check if the value is less than the minimum value
			if (value !== null && value !== undefined && value < minValue) {
				// If the value is less than the minimum value, return a validation error object
				return { min: true, actualValue: value, minValue: minValue };
			}

			// If the value is greater than or equal to the minimum value, return null (no validation error)
			return null;
		};
	}
}
